import NorthEastIcon from '@mui/icons-material/NorthEast';
import socialMedia from 'root/src/shared/constants/socialMedia';
import { DiscordIcon } from 'root/src/client/v2/common/components/icons/DiscordIcon';
import { CREATORS_PAGE_ROUTE_ID, PUBLISHERS_PAGE_ROUTE_ID, FAQ_ROUTE_ID, TERMS_OF_SERVICE_ROUTE_ID, COOKIE_POLICY_ROUTE_ID, PRIVACY_POLICY_ROUTE_ID, } from 'root/src/shared/descriptions/routes/routeIds';
import { EMAIL } from 'root/src/shared/constants/pageData';
import Link from 'root/src/client/web/base/Link';
import { RedesignLogo } from 'root/src/client/v2/layout/components/RedesignLogo';
// Real destinations mirror the legacy footer module (src/shared/descriptions/modules/newFooter.js).
const DISCORD_URL = socialMedia.discord;
const ABOUT_US_PATH = '/about-us'; // webflow page, full navigation
const PRESS_KIT_PATH = '/files/Dare_Drop_Brand_Kit.pdf';
const FOOTER_COLUMNS = [
    {
        category: 'Platform',
        links: [
            { label: 'For Creators', routeId: CREATORS_PAGE_ROUTE_ID },
            { label: 'For Publishers', routeId: PUBLISHERS_PAGE_ROUTE_ID },
            { label: 'FAQ', routeId: FAQ_ROUTE_ID },
        ],
    },
    {
        category: 'Company',
        links: [
            { label: 'About Us', href: ABOUT_US_PATH },
            { label: 'Contact Us', email: EMAIL },
            { label: 'Get Press Kit', download: PRESS_KIT_PATH },
        ],
    },
    {
        category: 'Legal',
        links: [
            { label: 'Terms of Service', routeId: TERMS_OF_SERVICE_ROUTE_ID },
            { label: 'Cookie Policy', routeId: COOKIE_POLICY_ROUTE_ID },
            { label: 'Privacy Policy', routeId: PRIVACY_POLICY_ROUTE_ID },
        ],
    },
];
const footerLinkClass = 'text-sm text-muted-foreground no-underline transition-colors hover:text-foreground';
const FooterLinkItem = ({ link }) => {
    if ('routeId' in link) {
        return <Link routeId={link.routeId} className={footerLinkClass}>{link.label}</Link>;
    }
    if ('email' in link) {
        return <a href={`mailto:${link.email}`} className={footerLinkClass}>{link.label}</a>;
    }
    if ('download' in link) {
        return <a href={link.download} download target="_blank" rel="noreferrer" className={footerLinkClass}>{link.label}</a>;
    }
    return <a href={link.href} className={footerLinkClass}>{link.label}</a>;
};
export const RedesignFooter = () => {
    const year = new Date().getFullYear();
    return (<footer className="redesign px-4 pb-6 pt-14 sm:px-6 lg:px-8">
			<div className="relative mx-auto max-w-7xl overflow-hidden rounded-xl border border-solid border-white/[0.06] bg-card p-8 sm:p-10">
				<div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-mixed"/>

				<div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-start">
					<div className="max-w-sm">
						<RedesignLogo />
						<p className="mt-3 text-sm leading-relaxed text-muted-foreground">
							The platform connecting game creators, publishers, and passionate gaming communities.
						</p>
					</div>

					<a href={DISCORD_URL} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2 rounded-lg bg-[#5865F2] px-4 py-2 text-sm font-medium text-white no-underline transition-opacity hover:opacity-90">
						<DiscordIcon className="h-4 w-4"/>
						Join Discord
						<NorthEastIcon sx={{ fontSize: 14 }} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"/>
					</a>
				</div>

				<div className="my-8 h-px bg-white/[0.06]"/>

				<div className="grid gap-8 sm:grid-cols-3">
					{FOOTER_COLUMNS.map(column => (<div key={column.category}>
							<h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{column.category}</h3>
							<ul className="mt-3 flex flex-col gap-2.5" role="list">
								{column.links.map(link => (<li key={link.label}><FooterLinkItem link={link}/></li>))}
							</ul>
						</div>))}
				</div>

				<div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-solid border-white/[0.06] pt-5 sm:flex-row">
					<p className="text-xs text-muted-foreground">&copy; {year} Dare Drop. All rights reserved.</p>
					<div className="flex items-center gap-5">
						<Link routeId={PRIVACY_POLICY_ROUTE_ID} className="text-xs text-muted-foreground no-underline transition-colors hover:text-foreground">Privacy</Link>
						<Link routeId={TERMS_OF_SERVICE_ROUTE_ID} className="text-xs text-muted-foreground no-underline transition-colors hover:text-foreground">Terms</Link>
					</div>
				</div>
			</div>
		</footer>);
};
